import React from 'react';
import { injectGlobal, ThemeProvider, } from "styled-components";
import { Shell, } from "codogo-react-widgets";

import MainView from "./components/mainview";

// -----------------------------------

injectGlobal`
	html, body, #root {
		width: 100% ;
		height: 100% ;
		margin: 0;
	}

	*, *:after, *:before {
		box-sizing: border-box;
	}

	body {
		font-family: Helvetica Neue,Segoe UI,Helvetica,Arial,sans-serif;
		color: ${Shell.defaultTheme.colors.black};
	}

	div {
		display: flex;
		flex-direction: column;
	}

	h1, h2, h3, h4, h5, h6, p {
		margin: 0;
	}

	a, a:hover, a:visited, a:active, a:link {
		color: ${Shell.defaultTheme.colors.black};
		text-decoration: none;
	}
`;

// -----------------------------------

export default () => 
	<ThemeProvider theme = { Shell.defaultTheme }>
		<MainView/>
	</ThemeProvider>;



// WEBPACK FOOTER //
// ./src/App.js